import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface UIState {
  isProfileDropdownOpen: boolean;
  isNotificationPanelOpen: boolean;
  toggleProfileDropdown: () => void;
  closeProfileDropdown: () => void;
  toggleNotificationPanel: () => void;
  closeNotificationPanel: () => void;
  closeAllDropdowns: () => void;
}

export const useUIStore = create<UIState>()(
  devtools(
    (set) => ({
      isProfileDropdownOpen: false,
      isNotificationPanelOpen: false,

      toggleProfileDropdown: () =>
        set((state) => ({
          isProfileDropdownOpen: !state.isProfileDropdownOpen,
          isNotificationPanelOpen: false, // Close other dropdowns
        })),

      closeProfileDropdown: () => set({ isProfileDropdownOpen: false }),

      toggleNotificationPanel: () =>
        set((state) => ({
          isNotificationPanelOpen: !state.isNotificationPanelOpen,
          isProfileDropdownOpen: false, // Close other dropdowns
        })),

      closeNotificationPanel: () => set({ isNotificationPanelOpen: false }),

      closeAllDropdowns: () =>
        set({
          isProfileDropdownOpen: false,
          isNotificationPanelOpen: false,
        }),
    }),
    { name: 'UIStore' }
  )
);
